import { useMemo } from 'react';
import { Card, CardHeader, CardTitle, CardBody } from '@vnetwork/ui/primitives';
import { RackLayoutView } from '@vnetwork/ui/data';
import { useRackItems, type Rack } from '@/api/capacities';
import { TabError, TabLoading } from '@/pages/customers/detail/tab-states';
import { toRackItem } from './rack-mappers';

/**
 * Rack Layout tab — the @ui `RackLayoutView` (front/rear U-grid) fed by the
 * rack's mounted items. Items lacking a real `rack_position_u` fall into the
 * widget's unpositioned list (expected with current staging data). The rack's
 * info card is rendered above the tabs by the detail page.
 */
export function RackLayoutTab({ rack }: { rack: Rack }) {
  const { data, isLoading, isError, refetch } = useRackItems(rack.id);

  const rackItems = useMemo(() => (data?.results ?? []).map(toRackItem), [data]);

  return (
    <Card flat>
      <CardHeader>
        <CardTitle>Rack Layout</CardTitle>
      </CardHeader>
      <CardBody>
        {isError ? (
          <TabError title="Failed to load rack items" onRetry={() => refetch()} />
        ) : isLoading ? (
          <TabLoading rows={6} />
        ) : (
          <RackLayoutView
            items={rackItems}
            uHeight={rack.u_height ?? 42}
            unpositionedTitle="Mounted (no U position)"
          />
        )}
      </CardBody>
    </Card>
  );
}
